import Cookies from "js-cookie";

const ServiceEnrollmentChecker = (cookieName, services = []) => {
    const cookieValue = Cookies.get(cookieName);
    if (!cookieValue) return false;

    // SYSADMIN override
    try {
        const access = JSON.parse(Cookies.get("access") || "[]");
        if (Array.isArray(access) && access.includes("SYSADMIN")) {
            return true;
        }
    } catch (e) {
        console.error("Invalid access cookie", e);
    }



    let oiEnrollments = [];
    try {
        oiEnrollments = decodeURIComponent(cookieValue)
            .split(",")
            .map(v => v.trim())
            .filter(Boolean);
    } catch (e) {
        console.error("Invalid oiEnrollments cookie", e);
        return false;
    }

    return Boolean(
        services.some(service => oiEnrollments.includes(service))
    );
};

export default ServiceEnrollmentChecker;
